import gql from 'graphql-tag';

export default gql`
  mutation AddUserProduct($input: AddUserProductInputType!) {
    dailyTracker {
      addUserProduct(input: $input) {
        __typename
        ... on AddedUserProduct {
          id
          name
          brand
          isUserProduct
          calories
          protein
          fat
          carbohydrates
          fiber
          unit
          requestId
        }
        ... on RateLimitExceeded {
          rateLimitExceededMessage: message
          rateLimitExceededDescription: description
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
